var path = '/templates/zenclerk_s/directives/zcs_maintenance/zcs_maintenance.html';
var html = "<div class=maintenance role=maintenance><div class=\"row col-md-6 col-md-offset-3\"><h1>{{ 'directives.zcsMaintenance.collectingData' | translate }}</h1><img src=/assets/img/maintenance.png zcs-hide-when-oem><p zcs-hide-when-oem translate=directives.zcsMaintenance.note translate-value-service=\"{{ vm.ZcsOemService.getName() }}\" translate-value-url=\"<a href='mailto:aideal-support@appier.com'>{{ 'directives.common.here' | translate }}</a>\"></p></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/directives/zcs_maintenance/zcs_maintenance.html
// module id = 1360
// module chunks = 0